import {
  AUTH_FETCH,
  AUTH_IS_FETCING,
} from 'constants/auth'

export default function authReducer(state={},action){
  switch (action.type) {
    case AUTH_FETCH:
        return {
          ...state,
          ...action.payload,
        }
    case AUTH_IS_FETCING:
      return {
        ...state,
        isFetching:action.payload,
      }
    default:
        return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js